<template>
  <!-- click.stop: the header cell sorts on click; filtering must not re-sort. -->
  <span class="roster-column-filter-menu ml-25" @click.stop>
    <floating-menu min-width="12rem">
      <template #button>
        <span class="d-inline-flex align-items-center" v-b-tooltip.hover :title="active ? `Filtering ${label}` : `Filter ${label}`">
          <feather-icon icon="FilterIcon" size="14" :class="active ? 'text-primary' : 'text-secondary'" />
          <b-badge v-if="active" pill variant="primary" class="ml-25" style="font-size: 0.7rem">{{ value.length }}</b-badge>
        </span>
      </template>

      <template #default="{ close }">
        <div class="py-50 px-1">
          <b-form-checkbox-group
            :checked="value"
            :options="options"
            value-field="value"
            text-field="label"
            stacked
            @input="(selected) => $emit('input', selected)"
          />
        </div>
        <template v-if="active">
          <div class="dropdown-divider" />
          <a
            href="#"
            class="dropdown-item"
            @click.prevent="
              close();
              $emit('input', []);
            "
            >Clear</a
          >
        </template>
      </template>
    </floating-menu>
  </span>
</template>

<script>
import { BBadge, BFormCheckboxGroup, VBTooltip } from 'bootstrap-vue';
import FloatingMenu from './FloatingMenu.vue';

/** Filter menu for one column, rendered in that column's header. */
export default {
  name: 'RosterColumnFilterMenu',
  components: { BBadge, BFormCheckboxGroup, FloatingMenu },
  directives: { 'b-tooltip': VBTooltip },
  props: {
    label: { type: String, required: true },
    /** [{ label, value }] */
    options: { type: Array, required: true },
    /** Selected values. */
    value: { type: Array, default: () => [] },
  },
  emits: ['input'],
  computed: {
    active() {
      return this.value.length > 0;
    },
  },
};
</script>
